import React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Skeleton,
} from "@mui/material";
import { tableHeaderStyles, tableCellStyles } from "../../../../utils/styles";

const ExpensesSkeleton: React.FC = () => (
  <>
    {/* Summary Card Skeleton */}
    <Paper sx={{ p: 2, mb: 2, backgroundColor: "grey.50" }}>
      <Skeleton variant="text" width={200} height={24} />
      <Skeleton variant="text" width={150} height={20} />
    </Paper>

    {/* Table Skeleton */}
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell {...tableHeaderStyles}>Date</TableCell>
            <TableCell {...tableHeaderStyles}>Description</TableCell>
            <TableCell {...tableHeaderStyles}>Category</TableCell>
            <TableCell {...tableHeaderStyles}>Amount</TableCell>
            <TableCell {...tableHeaderStyles}>Created By</TableCell>
            <TableCell {...tableHeaderStyles}>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {[...Array(4)].map((_, index) => (
            <TableRow key={index}>
              <TableCell {...tableCellStyles}>
                <Skeleton variant="text" width={80} height={16} />
              </TableCell>
              <TableCell {...tableCellStyles}>
                <Skeleton variant="text" width="100%" height={16} />
              </TableCell>
              <TableCell {...tableCellStyles}>
                <Skeleton variant="rectangular" width={80} height={20} sx={{ borderRadius: 1 }} />
              </TableCell>
              <TableCell {...tableCellStyles}>
                <Skeleton variant="text" width={80} height={16} />
              </TableCell>
              <TableCell {...tableCellStyles}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Skeleton variant="circular" width={24} height={24} />
                  <Skeleton variant="text" width={120} height={16} />
                </Box>
              </TableCell>
              <TableCell {...tableCellStyles}>
                <Skeleton variant="circular" width={24} height={24} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </>
);

export default ExpensesSkeleton; 